import axios from 'axios';
import LogRocket from 'logrocket';
import { getCookie } from '../../utils/cookieUtils';
import jwtDecode from 'jwt-decode';
import { getEnvVariable } from '../../utils/envUtils';
var recordingURL;
LogRocket.getSessionURL(function (sessionURL) {
  recordingURL = sessionURL;
});
var vanityURL = getEnvVariable('providerVanityURL');
export var getHashFragment = function (state) {
  return axios.get('/dental/authn-callback/hash-fragment', {
    params: {
      state: state
    }
  });
};
export var cancelToken = function () {
  var token = getCookie('dppAuthToken');
  if (token) {
    var decodedToken = jwtDecode(token);
    //@ts-ignore
    var uuid = decodedToken["".concat(vanityURL, "jti")];
    return axios.post("/token-blacklist-service/api/token", {
      uuid: uuid
    }, {
      headers: {
        authorization: "Bearer ".concat(token),
        'X-LogRocket-URL': recordingURL
      }
    });
  }
};